module.exports = __webpack_public_path__ + "img/home-email.8ca3e00d.svg";